"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PolicyCarData_1 = require("../models/PolicyCarData");
var mockPolicyCarData = __assign(__assign({}, PolicyCarData_1.makeEmptyPolicyCarData()), { plate: 'mock-plate', carYear: 'mock-year', serialMotor: 'mock-serial-motor', serialVin: 'mock-serial-vin' });
exports.default = mockPolicyCarData;
//# sourceMappingURL=mockPolicyCarData.js.map